import { createSlice } from "@reduxjs/toolkit";
import refundLaterApi from "@custom/rtk-apis/billing/invoice/refundLater";

const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  error:""
};

const refundLaterSlice = createSlice({
  name: "refundLaterSlice",
  initialState,
  reducers: {
    closeModal (state:any) { state.status = ""; }
  },
  extraReducers: (builder) => {
    builder
      .addCase(refundLaterApi.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(refundLaterApi.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(refundLaterApi.rejected, (state, { payload }) => {
        state.result = payload;
        state.loading = false;
      });
  },
});

export default refundLaterSlice.reducer;
export const { closeModal } = refundLaterSlice.actions;
